import React from 'react';

export const ABContext = React.createContext({});
export default ABContext;
